import {
  ActionProcessMode,
  IContextMenuItemRefreshRules,
} from '@infotech-soe/metaschema';

import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommandImpl from './CategoryCommandImpl';

class SettingsCommandImpl extends CategoryCommandImpl<void> {
  public getUserInteractor(): UserInteractor {
    return {
      type: UserInteractorType.SETTINGS_FORM,
    };
  }

  public async execute(): Promise<void> {
    // not implemented
  }

  public async getInitialArgs(): Promise<any> {
    // not implemented
  }

  public getName(): CommandName {
    return 'settings';
  }

  public getProcessMode(): ActionProcessMode {
    return 'Any';
  }

  public getRefreshRules(): IContextMenuItemRefreshRules | undefined {
    return undefined;
  }
}

export default SettingsCommandImpl;
